import { SLOTS } from 'types';
import { truncationNumber } from 'utils/transformToCurrency';
import { BetType } from '../types';

export const buildTruncatedBetPayload = (bet: BetType): BetType => {
  const slots = Object.values(SLOTS);

  return slots.reduce<BetType>((acc, slot) => {
    acc[slot] = truncationNumber(bet[slot]);
    return acc;
  }, {} as BetType);
};
